import React from "react";
import { Box, Typography, Container, useTheme } from "@mui/material";
import { Helmet } from "react-helmet";
import HistoricalSignalsContent from "./HistoricalSignalsContent";
const HistoricalSignals = () => {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Historical Signals</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor: theme.palette.mode === 'light' 
            ? '#ebebeb'
            : theme.palette.grey[50],
          background: theme.palette.mode === 'light' 
            ? '#ebebeb'
            : theme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                mb: 1,
              }}
            >
              Historical Signals
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
              }}
            >
              View and manage historical trading signal sets across strategies
            </Typography>
          </Box>
          <HistoricalSignalsContent />
        </Container>
      </Box>
    </>
  );
};

export default HistoricalSignals;
